import axios from "axios";
import encrypt from '../utils/crypto-util';


console.log(import.meta.env.VITE_API_BASE_URL, 'import.meta.env.VITE_API_BASE_URL');



axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL


/**数据加密 */
let aecdata: any
let md5: any
let md51: any
// 进行加密处理
/**生成随机数 */

function getRandomnum() {
    let uuid = encrypt.uuid()
    let md5uuid = encrypt.md5(uuid)
    return md5uuid.toLowerCase()
}

/**生成uuid */
function getUuid() {
    const UUID_STORAGE_KEY = 'app_uuid';
    // 1. 首先检查本地存储中是否存在uuid
    let storedUuid = localStorage.getItem(UUID_STORAGE_KEY);
    // 2. 如果存在则直接使用本地存储的uuid
    if (storedUuid && storedUuid.length === 32) {
        // 验证存储的uuid格式是否正确（32位小写字符）
        if (/^[a-f0-9]{32}$/.test(storedUuid)) {
            return storedUuid;
        }
    }
    // 3. 如果不存在则生成一个新的uuid
    let uuid = encrypt.uuid();
    let md5uuid = encrypt.md5(uuid);
    let finalUuid = md5uuid.toLowerCase();

    // 4. 将新生成的uuid存储到本地
    localStorage.setItem(UUID_STORAGE_KEY, finalUuid);

    return finalUuid;
}
/**
 *  获取当前语言 用户语言（zh-CN：简体中文，en：英文）。非简体中文的默认均为英文
 */
function getCurrentLanguage(): string {
    try {
        // 2. 从浏览器navigator获取系统语言
        const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';

        // 3. 判断是否为简体中文
        if (browserLanguage.toLowerCase().includes('zh-cn') ||
            browserLanguage.toLowerCase().includes('zh_cn') ||
            browserLanguage.toLowerCase() === 'zh') {
            return 'zh-CN';
        }

        // 4. 检查是否为其他中文变体，但仍返回简体中文
        if (browserLanguage.toLowerCase().startsWith('zh')) {
            // 可以根据需要调整，这里统一返回简体中文
            return 'zh-CN';
        }

        // 5. 非简体中文的默认均为英文
        return 'en';

    } catch (error) {
        // 6. 异常情况下默认返回英文
        console.warn('获取语言设置失败，使用默认语言:', error);
        return 'en';
    }
}

/**
 * 获取客户端类型
 * @returns {string} 客户端类型枚举值
 * 1：androidAPP，2：iOSAPP，3：harmonyosAPP，4：web，5：wechatMini，
 * 6：douyinMini，7：alipayMini，8：pcAPP，99：其他
 */
function getClientType(): string {
    try {
        const ua = navigator.userAgent.toLowerCase();
        
        // 检测微信小程序
        if (typeof window !== 'undefined' && (window as any).__wxjs_environment === 'miniprogram') {
            return '5'; // wechatMini
        }
        
        // 检测微信小程序（另一种方式）
        if (ua.includes('miniprogram') || ua.includes('micromessenger/')) {
            // 进一步判断是否在小程序环境
            if (typeof (window as any).wx !== 'undefined' && (window as any).wx.miniProgram) {
                return '5'; // wechatMini
            }
        }
        
        // 检测抖音小程序
        if (ua.includes('toutiaomicroapp') || typeof (window as any).tt !== 'undefined') {
            return '6'; // douyinMini
        }
        
        // 检测支付宝小程序
        if (ua.includes('alipayclient') || typeof (window as any).my !== 'undefined') {
            return '7'; // alipayMini
        }
        
        // 检测Electron（桌面应用）
        if (ua.includes('electron')) {
            return '8'; // pcAPP
        }
        
        // 默认返回web
        return '4'; // web
        
    } catch (error) {
        console.warn('获取客户端类型失败，使用默认值:', error);
        return '4'; // 默认web
    }
}

/**
 * 获取客户端操作系统类型
 * @returns {string} 操作系统类型枚举值
 * 1：Android，2：iOS，3：HarmonyOS，4：Windows，5：Linux，6：macOS，99：其他
 */
function getClientOS(): string {
    try {
        const ua = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();
        
        // 检测 Android
        if (ua.includes('android')) {
            return '1'; // Android
        }
        
        // 检测 iOS (iPhone, iPad, iPod)
        if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
            return '2'; // iOS
        }
        
        // 检测 iOS (通过平台信息)
        if (platform.includes('iphone') || platform.includes('ipad') || platform.includes('ipod')) {
            return '2'; // iOS
        }
        
        // 检测 HarmonyOS
        if (ua.includes('harmonyos') || ua.includes('openharmony')) {
            return '3'; // HarmonyOS
        }
        
        // 检测 macOS
        if (platform.includes('mac') || ua.includes('macintosh') || ua.includes('mac os x')) {
            return '6'; // macOS
        }
        
        // 检测 Linux
        if (platform.includes('linux') || ua.includes('linux')) {
            // 排除 Android (Android 基于 Linux)
            if (!ua.includes('android')) {
                return '5'; // Linux
            }
        }
        
        // 检测 Windows
        if (platform.includes('win') || ua.includes('windows')) {
            return '4'; // Windows
        }
        
        // 未知系统
        return '99'; // 其他
        
    } catch (error) {
        console.warn('获取操作系统类型失败，使用默认值:', error);
        return '4'; // 默认Windows
    }
}

// 请求拦截器，响应拦截器
// 添加请求拦截器
axios.interceptors.request.use(function (config: any) {
    // 获取时间戳
    let time: any = new Date().getTime()
    // 获取随机数
    let Randomnum = getRandomnum()
    // 检测客户端类型和操作系统（仅首次输出）
    if (!(window as any).__clientInfoLogged) {
        const clientType = getClientType()
        const clientOS = getClientOS()
        const clientTypeMap: Record<string, string> = {
            '1': 'androidAPP', '2': 'iOSAPP', '3': 'harmonyosAPP', '4': 'web',
            '5': 'wechatMini', '6': 'douyinMini', '7': 'alipayMini', '8': 'pcAPP', '99': '其他'
        }
        const clientOSMap: Record<string, string> = {
            '1': 'Android', '2': 'iOS', '3': 'HarmonyOS', '4': 'Windows',
            '5': 'Linux', '6': 'macOS', '99': '其他'
        }
        console.log(`🖥️ [客户端检测] 类型: ${clientTypeMap[clientType]} (${clientType}), 系统: ${clientOSMap[clientOS]} (${clientOS})`)
        ;(window as any).__clientInfoLogged = true
    }
    // aec加密数据
    if (config.data) {
        // console.log('走这里');
        aecdata = encrypt.aesEncrypty(config.data)
        if (config.ablen == 1) {
            // console.log('不发送数据');
        } else {
            // console.log('发送数据', config.data, aecdata);
            config.data = aecdata
            // console.log(config.data, '加密并且 重新赋值后的发送数据');

        }
    }

    // md5(pp-sign-data:data=${data}&nonceStr=${nonceStr}&timestamp=${timestamp})
    // let data1 = `pp-sign-data:data=${aecdata}&nonceStr=${Randomnum}&timestamp=${time}`
    // let data2 = `pp-sign-data:data=&nonceStr=${Randomnum}&timestamp=${time}`
    let data = `pp-sign-data:data=${aecdata}&nonceStr=${Randomnum}&timestamp=${time}`
    let data1 = `pp-sign-data:data=&nonceStr=${Randomnum}&timestamp=${time}`
    // console.log(
    //     config.data, '加密后请求数据'
    // );
    // console.log(
    //     data, '加密前的数据 sign'
    // );
    // 获取MD5加密数据
    md5 = encrypt.md5(data).toLowerCase()
    md51 = encrypt.md5(data1).toLowerCase()
    config.headers = {
        ...config.headers,
        'h_client': getClientType(),
        'h_os': getClientOS(),
        'h_language': getCurrentLanguage(),
        'h_version': '1.1.1',
        'h_channel': 'official',
        'h_uuid': getUuid(),
        'h_timestamp': time,
        'h_nonceStr': Randomnum,
        'h_sign': config.ablen == 1 ? md51 : md5,
        'h_token': localStorage.getItem('usetoken') ? localStorage.getItem('usetoken') : '',
        'Content-Type': 'text/plain'
    }
    // 在发送请求之前做些什么  
    return config;
}, function (error) {
    console.error('请求报错', error);
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    const data = JSON.parse(encrypt.aesDecrypt(response.data))
    // 测试状态  /promotion/media/edit 如果请求的是这个就就进行token失效测试
    // if (response.config.url === '/promotion/media/edit') {
    //     data.code = 10006
    // }

    // 【核心功能】检测 Token 失效（code=10006）
    if (data.code === 10006) {
        // 动态导入以避免循环依赖
        import('../router/router').then(routerModule => {
            const router = routerModule.default
            const currentRoute = router.currentRoute.value

            // 动态导入 FormCache Store
            import('../stroe/formCache').then(storeModule => {
                const { useFormCacheStore } = storeModule
                const formCacheStore = useFormCacheStore()

                // 保存当前路由信息
                formCacheStore.saveRedirectRoute(currentRoute)

                // 触发全局事件，通知当前页面保存表单数据
                window.dispatchEvent(new CustomEvent('token_expired_save_form', {
                    detail: {
                        routePath: currentRoute.path,
                        timestamp: Date.now()
                    }
                }))

                console.log('🔔 [Token失效] 已触发表单保存事件')

                // 延迟 150ms 确保事件处理完成
                setTimeout(() => {
                    // 清除本地认证信息
                    localStorage.removeItem('usetoken')
                    localStorage.removeItem('userinfo')
                    localStorage.removeItem('uid')
                    // localStorage.clear()

                    // 提示用户
                    import('element-plus').then(elementPlus => {
                        elementPlus.ElMessage.warning({
                            message: '登录已过期，请重新登录',
                            duration: 2000,
                            showClose: true
                        })
                    })

                    // 跳转登录页
                    router.push('/Login')
                }, 150)
            })
        })

        // 返回一个被拒绝的 Promise，阻止后续处理
        return Promise.reject({
            code: 10006,
            msg: '登录已过期',
            isTokenExpired: true
        })
    }

    return data

}, function (error) {

    console.error('接收报错', error);

    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});
declare module 'axios' {
    interface AxiosInstance {
        (config: AxiosRequestConfig): Promise<any>
    }
}
export default axios
